import React from 'react'
import { withTranslation } from 'react-i18next'
import useSWR from 'swr'
import RankedDonutCard from 'components/DetailWidgets/RankedDonutCard'

export default withTranslation()(function LoyalMetrics({ t }) {
  const { data } = useSWR('dashboard/loyalty-metrics')

  const [total, newCustomers, returning, lost] = [
    data?.data?.total_customers ?? 0,
    data?.data?.new_customers ?? 0,
    data?.data?.returning_customers ?? 0,
    data?.data?.lost_customers ?? 0
  ]

  const segments = [
    { key: 'returning', label: t('overview.returning_customers'), value: returning, color: '#1976D2' },
    { key: 'new', label: t('overview.new_customers'), value: newCustomers, color: '#DCA815' },
    { key: 'lost', label: t('overview.lost_customers'), value: lost, color: '#FF3B30' }
  ]

  const sum = segments.reduce((acc, segment) => acc + segment.value, 0) || 1
  const data_ = segments.map((segment) => ({
    label: segment.label,
    color: segment.color,
    percent: Math.round((segment.value / sum) * 100)
  }))

  return (
    <RankedDonutCard
      title={t('overview.customer_breakdown')}
      centerValue={total}
      centerLabel={t('overview.total_customers')}
      data={data_}
    />
  )
})
